import {enableProdMode}         from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry              from '@sentry/angular';
import packageInfo              from '../package.json';
import {AppModule}              from './app/app.module';
import {environment}            from './environments/environment';

if (environment.production || environment.environmentName == 'staging') {
    Sentry.init({
        dsn: environment.sentryDSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        release: `${packageInfo.name}@${packageInfo.version}`,
        environment: environment.environmentName,
        tracesSampleRate: 0.1,
        tracePropagationTargets: [
            'localhost',
            'localhost:4200',
            'vulcan-api.test',
            '192.168.1.46:8100',
            'staging.api.vulcan.hickwood.uk',
            'test.api.vulcan.hickwood.uk',
            'api.firesurveypro.co.uk'
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
